import Vue from 'vue';
import axios from 'axios';
// import { Message } from '@ts/element-ui';
import cookie from '@/utils/cookie';
import {axiosBaseUrl } from '@/utils/domain';

let redirectLocation = '';
const service = axios.create({
  baseURL: axiosBaseUrl
});
// 请求拦截器
service.interceptors.request.use(
  async config => {
    const token = cookie.get('teamsun_dn_workbench_token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  response => {
    // 成功执行
    const { message } = response.data;
    // 只拦截接口状态
    if (response.status === 200) {
      if (response.data && response.data.code === 400300002) {
        // token校验失败，跳转到中台登录页
        // http://172.18.117.71:8080/#/login?app=dn-fe-web&redirect=http://172.18.117.71:8080/dn-workbench/#/basic-config/recommend
        // 两个接口同时触发会导致地址出错bugfix
        // if (redirectLocation !== decodeURIComponent(window.location.href)) {
        //   redirectLocation = `${window.location.protocol}${domain}#/login?app=dn-fe-workbench&redirect=${window.location.href}`;
        // }
        // store.commit('user/reset');
        // store.commit('main/reset');
        // store.commit('session/reset');
        // store.commit('customer/reset');
        // window.CalliBarFeSdk && window.CalliBarFeSdk.destroy();
        // window.location = redirectLocation;
        return response.data;
      } else {
        return response.data; // 返回接口数据
      }
    } else {
      // 当接口失败的时候
      // Message.error(message); // 提示消息
      // return Promise.reject(new Error(message));
    }
  },
  async error => {
    // Message.error(error.message); // 提示错误
    // return Promise.reject(error); // 传入一个错误的对象  就认为promise执行链 进入了catch
  }
);

const methods = [
  'get',
  'delete',
  'head',
  'options',
  'post',
  'put',
  'patch',
  'read',
  'create',
  'update'
];
methods.map(method => {
  service[method] = function (url, params = {}, moreConfig = {}) {
    const config = {};
    if (method == 'get') {
      config.params = params;
    } else {
      config.data = params;
    }
    config.method = method;
    config.url = url;
    let headers = {
      'Content-Type': 'application/json'
    };
    config.headers = Object.assign(headers, moreConfig.headers);
    config.withCredentials = true;
    if (moreConfig.cancelToken) {
      config.cancelToken = moreConfig.cancelToken;
    }
    if (moreConfig.transformRequest) {
      config.transformRequest = moreConfig.transformRequest;
    }
    if (moreConfig.responseType) {
      config.responseType = moreConfig.responseType;
    }
    if (moreConfig.onUploadProgress) {
      config.onUploadProgress = moreConfig.onUploadProgress;
    }
    return service.request(config);
  };
});

if (!Vue.prototype.$axios){
  Vue.prototype.$axios = service;
}

export default service;
